<template>
  <div class="wrapper">
    <div class='nowBox'>
      <!-- <div :style='now==item?"color:#141414;font-weight:bold;":""' v-for='item in navList' @click="dev(item)">{{item}}</div> -->
     <!--  <div class="business_box">
        <span @click="seller" v-if="isSupplier" :class="{ 'active': business == 'seller' }">我卖出的</span>
        <span @click="buyer" :class="{ 'active': business == 'buyer' }">我买到的</span>
      </div> -->
    </div>
    <!-- v-if="!supplierInfo && business == 'buyer' || supplierInfo && business == 'seller' || supplierInfo && business == 'buyer'" -->
    <div class="main">
      <div class="sideNav" v-if="toggle_show_saleorder || business == 'buyer'">
        <!-- <div class="business_box">
          <span @click="buyer" :class="{ 'active': business == 'buyer' }">我买到的</span>
          <span @click="seller" :class="{ 'active': business == 'seller' }">我卖出的</span>
        </div> -->
        <div class="order_category_box">
          <!-- <span :style='now==item?"color:#141414;font-weight:bold;border-bottom: 1px solid rgba(51, 51, 51, 1);":""' v-for='item in navList' @click="dev(item)">{{item}}</span> -->
        </div>
        <div
          :class="{ 'active': target == item.id }"
          v-for="item in menu"
          :key="item.id"
          @click="changeMenu(item.id)"
          class="orderstate"
        >
          <span>{{item.name}}</span><span v-if="business == 'seller'">({{item.num}})</span>
        </div>
      </div>
      <div class="content">
        <div class="header">
          <div class="header_left">
            <div class='addOrderIconBtn' v-if="business == 'seller'" @click="addOrder"><img src="../../assets/add_order.png" alt=""> <span>添加订单</span></div>
            <div class='addOrderIconBtn' v-if="business == 'buyer'" @click="addPurchaseOrder"><i class='el-icon-circle-plus-outline'></i>添加采购单</div>
            <div class="filter-sale-order" v-if="!toggle_show_saleorder && business == 'seller'">
              <el-select v-model="sales_order_status" @change="changeMenu(sales_order_status)">
                <el-option v-for="item in menu" :key="item.id" :label="item.name + (business == 'seller' ? `(${item.num})` : '(0)' )" :value="item.id"></el-option>
              </el-select>
            </div>
            <div class='addGoodsIconBtn' v-if="business == 'buyer'" @click="toPurchase"><i class='el-icon-shopping-cart-1'></i>去商城采购</div>
            <div class="operBtn" @click="openPrint">
              <span><img src="../../assets/icon_printing-01@2x.png" alt=""> 打印</span><span>({{printArr.length}})</span>
            </div>
            <div class="operBtn" v-if="business == 'seller'" @click="warehouseOutClick">
              <span><img src="../../assets/icon_holegroove-01@2x.png" alt=""> 出库</span>
              <!-- ({{warehouseOutArr.length}}) -->
            </div>
            <div class="operBtn" v-if="business == 'seller'" @click="deliverGoodsClick">
              <span><img src="../../assets/wuliu.png" alt=""> 发货</span>
              <!-- ({{deliverGoodsArr.length}}) -->
            </div>
            <div class="operBtn" v-if="business == 'buyer'" @click="warehouseClick">
              <span><img src="../../assets/icon_import-01.png" alt=""> 入库</span>
              <!-- ({{warehouseArr.length}}) -->
            </div>
            <!-- <div>
              
            </div> -->
          </div>
          <div class="header_right">
            <div class="toggle-show-sale" v-if="business == 'seller'">
              <el-switch v-model="toggle_show_saleorder" inactive-text="列表显示" active-color="#0000fe"></el-switch>
            </div>
            <div class="orderMsgSetting" @click="settingBoxVisibleShow" v-if="business == 'seller'">设置</div>
            <el-dialog
              :visible.sync="settingBoxVisible"
              width="30%"
              >
              <div>
                <div><el-checkbox v-model="print_outStock">打印即自动出库</el-checkbox></div>
                <div style="marginTop:10px;cursor: pointer;color:#6376F7;"><span @click="showMsgSetting">单据格式设置</span></div>
              </div>
              
            </el-dialog>
            <!--单据格式弹框-->
            <el-dialog :visible.sync="msgSettingVisible" width="600px" title="销售单格式信息设置">
              <div class="remark_box">
                <el-row>
                  <!-- <el-col :span="8">
                    <span class="remark_area">备注区1:</span><br>
                    <span class="remark_msg"><i>填写银行卡信息</i></span>
                  </el-col> -->
                  <el-col :span="24">
                    <span class="remark_msg"><i>填写银行卡信息</i></span>
                    <!-- <textarea class="remark_input" v-model="idCardInfo"></textarea> -->
                    <div id="bandInput" class="text"></div>
                  </el-col>
                </el-row>
              </div>
              <div class="remark_box">
                <el-row>
                  <!-- <el-col :span="8">
                    <span class="remark_area">备注区2:</span><br>
                    <span class="remark_msg"><i>发货说明等</i></span>
                  </el-col> -->
                  <el-col :span="24">
                    <span class="remark_msg"><i>发货说明等</i></span>
                    <!-- <textarea class="remark_input" v-model="shipmentsInfo"></textarea> -->
                    <div id="remarkInput"></div>
                  </el-col>
                </el-row>
              </div>
              <div class="clearfix msgSet_box">
                <button class="msgSet_submit" @click="msgSettingSubmit">保存</button>
                <button class="msgSet_cancel" @click="msgSettingVisible = false">取消</button>
              </div>
            </el-dialog>
            <div class="timeSelector">
              <el-select v-model="timeRange">
                <el-option
                  v-for="item in timeOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </div>
            <div class="keywordSearching" v-if="business == 'seller'">
              <img @click="search" src="../../assets/orderQuery/searching.svg" alt="">
              <input type="text" placeholder="请在此输入客户名/电话/地址搜索" v-model="order_filter" @keyup.enter="search">
              <div class="buttons">
                <img @click="clearKeyword" v-if="order_filter != ''" src="../../assets/orderQuery/clearSearching.svg" alt="">
              </div>
            </div>
            <div class="keywordSearching" v-else>
              <img @click="search" src="../../assets/orderQuery/searching.svg" alt="">
              <input type="text" placeholder="请在此输入供货方/电话/地址搜索" v-model="buyerOrderFilter" @keyup.enter="search">
              <div class="buttons">
                <img @click="clearKeyword" v-if="buyerOrderFilter != ''" src="../../assets/orderQuery/clearSearching.svg" alt="">
              </div>
            </div>
          </div>
        </div>
        <div class="sales-order-table" v-if="!toggle_show_saleorder && business == 'seller'">
          <salesOrderTable :orderList="orderList" :page='businessPage' ref="sales_order_table" :getOrderList='getOrderList'></salesOrderTable>
        </div>
        <div class="orderList" v-if="toggle_show_saleorder || business == 'buyer'">
          <div class="orderItemWrapper"
            v-for="item in orderList"
            :key="item.id"
          >
            <OrderItem
              @getOrderList='getOrderList'
              @checkLogistic="checkLogistic"
              @orderItemSearch='orderItemSearch'
              @delete="deleteOrder"
              :orderInfo="item"
              :business='business'
              :forward='forwardSupplierList'
              @pay="payOrder"
              @confirmReceipt = "confirmReceipt"
              @confirmShipment = 'confirmShipment'
              @upDataOrderList = 'upDataOrderList'
              @showOutStockBox = 'showOutStockBox'
              @yesPrint = 'yesPrint'
              @noPrint = 'noPrint'
              @modifyOrderState = 'modifyOrderState'
            />
            <div class="mask" v-if="item.commodity_list.length == 0">
              <!-- <div class="operation">
                <img src="../../assets/orderQuery/deleteOrder.svg" alt="" @click="deleteOrder(item.id)">
              </div> -->
              <div>
                <p>该商品已下架 !</p>
                <i class="el-icon-delete" style="cursor: pointer;" @click="deleteOrder(item.id)"></i>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="order_paging_box">
      <el-button v-show="business == 'buyer'" @click="previousPage" :disabled='userPage == 1'>上一页</el-button>
      <el-button v-show="business == 'buyer'" @click="nextPage" :disabled='userPage == userTotalPage'>下一页</el-button>
      <el-button v-show="business == 'seller'" @click="businessPreviousPage" :disabled='businessPage == 1'>上一页</el-button>
      <el-button v-show="business == 'seller'" @click="businessNextPage" :disabled='businessPage == businessTotalPage'>下一页</el-button>
    </div>
    <!-- 支付二维码弹框 -->
    <!-- <div class="payment_mask_box" v-if="paymentMaskIsShow" @click="hideMask">
      <div class="payment_box">
          <div class="back_img_box"><img class="backImg" @click="noPay" src="../../assets/icon_chacha_b.png" alt=""></div>
          <p class="order_title">请支付订单</p>
          <Qrcode :codeUrl='codeInfo.url'></Qrcode>
          <div class="QRcode_box">
            <img src="../../assets/002.png" alt="">
          </div>
          <p class="payPrice">需支付金额：{{totalAmount}}元</p>
          <p class="tips">请使用微信扫码支付</p>
          <div class="other_payments_box">
            <span>柜柜钱包：￥{{0}}</span><el-button @click="ggPayment">用柜柜钱包余额支付</el-button>
          </div>
      </div>
    </div> -->
    <div class="outMask" v-if="outStockBoxShow">
      <outStockBox @getOrderList='getOrderList' @hideOutStockBox='hideOutStockBox' :info='warehouseOutArr[0]' :address='address'></outStockBox>
    </div>
    <div class="outMask" v-if="deliverGoodsShow">
      <deliverGoods @hideDeliverGoods='hideDeliverGoods' @DeliverGoodsUpData='DeliverGoodsUpData' :orderInfo="deliverGoodsArr[0]"></deliverGoods>
    </div>
    <PaymentPanel
      :visible="paymentPanelShown"
      @close="cancelPayment"
      :wechatLink="wechatLink"
      @cancelPayment="skipToOrderList"
    />
  </div>
</template>

<script>
import outStockBox from '../../components/cloud/cloudOrderManage/outStockBox.vue'
import deliverGoods from '../../components/cloud/cloudOrderManage/deliverGoods.vue'
import OrderItem from '../../components/cloud/OrderItem.vue'
import QRCode from "qrcodejs2";
import Qrcode from '../../components/cloud/Qrcode'
import { mapState,mapGetters } from 'vuex'
import {handlePartOutImportStock} from '../../util/processingData'
import PaymentPanel from '../../components/cloud/PaymentPanel.vue'
import salesOrderTable from './salesOrderTable.vue'
import E from 'wangeditor'
// import {  getPaymentLink, getOrderStatus,saveBill,sellerBuyerBindOrderId } from '../../util/requests';
export default {
  components: {
    OrderItem,
    Qrcode,
    PaymentPanel,
    outStockBox,
    deliverGoods,
    salesOrderTable
  },
  data() {
    return {
      // 是否显示列表
      toggle_show_saleorder: true,
      // 记录下拉框默认值
      sales_order_status: 0,
      forwardSupplierList:[],//我的供应商列表
      address:{},
      outStockBoxShow:false,
      outStockInfo:{},
      // supplier_id: -1,
      wechatLink: '',
      paymentId: '',
      queryStatusInterval: '',
      paymentPanelShown: false,
      status:[],//采购订单状态
      sellerStatus: [],//销售订单状态
      status_mark: 0,//文件夹式销售单分类
      codeInfo: '',
      payId: -1,
      totalAmount: 0,
      paymentMaskIsShow: false,
      // now:'材料订单',
      navList:['材料订单','画册&色卡订单'],
      business:'seller',//卖家
      timeRange: 1,
      timeOptions: [{
        value: 1,
        label: '最近7天'
      }, {
        value: 2,
        label: '最近1个月'
      }, {
        value: 3,
        label: '最近3个月'
      }, {
        value: 4,
        label: '最近半年'
      }, {
        value: 5,
        label: '最近1年'
      }, {
        value: 6,
        label: '最近3年'
      }],
      target: 0,
      menu: [],
      sellMenu: [
        // {
        //   id: 1,
        //   name: '全部'
        // },{
        //   id: 2,
        //   name: '待收款'
        // },{
        //   id: 3,
        //   name: '已收款'
        // },{
        //   id: 4,
        //   name: '待发货'
        // },{
        //   id: 5,
        //   name: '已完成'
        // }
        {
          id: -1,
          name: '全部',
          num: 0
        },
        {
          id: 0,
          name: '未受理',
          num: 0
        },
        {
          id: 1,
          name: '待收款',
          num: 0
        },
        {
          id: 2,
          name: '未付清',
          num: 0
        },
        {
          id: 3,
          name: '已付清',
          num: 0
        },
        {
          id: 4,
          name: '在生产',
          num: 0
        },
        {
          id: 5,
          name: '待发货',
          num: 0
        },
        {
          id: 6,
          name: '欠货',
          num: 0
        },
        {
          id: 7,
          name: '已发货',
          num: 0
        },
        {
          id: 8,
          name: '待退款',
          num: 0
        },
        {
          id: 9,
          name: '已退款',
          num: 0
        },{
          id: 10,
          name: '草稿箱',
          num: 0
        }
        
      ],
      buyMenu: [
        {
          id: 1,
          name: '全部'
        },{
          id: 2,
          name: '待付款'
        },{
          id: 3,
          name: '待发货'
        },{
          id: 4,
          name: '待收货'
        },{
          id: 5,
          name: '已完成'
        }
        // {
        //   id: -1,
        //   name: '全部',
        //   num: 0
        // },
        // {
        //   id: 1,
        //   name: '待付款',
        //   num: 0
        // },
        // {
        //   id: 2,
        //   name: '未付清',
        //   num: 0
        // },
        // {
        //   id: 3,
        //   name: '已付清',
        //   num: 0
        // },
        // {
        //   id: 4,
        //   name: '在生产',
        //   num: 0
        // },
        // {
        //   id: 5,
        //   name: '待发货',
        //   num: 0
        // },
        // {
        //   id: 6,
        //   name: '欠货',
        //   num: 0
        // },
        // {
        //   id: 7,
        //   name: '待收货',
        //   num: 0
        // },
        // {
        //   id: 8,
        //   name: '待退款',
        //   num: 0
        // },
        // {
        //   id: 9,
        //   name: '已退款',
        //   num: 0
        // },{
        //   id: 10,
        //   name: '已完成',
        //   num: 0
        // }
      ],
      orderList: [],
      //支付
      paymentPanelShown: false,
      userPage:1,//用户当前页
      userTotalPage:1,//用户订单总数

      businessPage:1,//商家当前页
      businessTotalPage:1,//商家订单总数
      moneyList:[],//尾款
      isSupplier: true,
      msgSettingVisible: false, // 显示单据格式配置
      idCardInfo: '', // 设置单据格式信息配置中银行卡信息
      shipmentsInfo: '', // 单据格式信息配置中发货说明
      printArr: [],
      order_type: 1,//获取尾款、默认销售单
      payed_money:0, //当前出入库已收款金额
      payed_name:'',//当前收货方name
      order_id:'' ,//当前订单id

      warehouseOutArr: [],//出库

      deliverGoodsShow: false,//发货弹框
      deliverGoodsArr: [],//发货order_id

      warehouseArr: [],//入库
      order_filter: '',//订单模糊搜索
      buyerOrderFilter: '',//采购单模糊搜索

      is_sales: 1,//获取订单状态数量（默认销售）
      editor:null,
      editor1:null,
      editorData:'',
      editorData1:'',
      settingBoxVisible:false,
      print_outStock:false

    }
  },
  computed: {
    
    // this.$store.state.identityMode,this.$store.getters.staffInfo
    ...mapState([
      'supplierInfo','userInfo','identityMode'
    ]),
    ...mapGetters({
      staffInfo:'staffInfo'
    }),
    supplier_id(){
      if(this.$store.state.supplierInfo){
          return this.$store.state.supplierInfo.id
      }else{
          return 0
      }
    },
    businessC(){
      this.business = this.$route.params.business;
      if(this.business == 'seller'){
        // console.log('business',this.business)
        this.menu = this.sellMenu

        this.seller()
        this.order_type = 1
        this.is_sales = 1
        this.printArr = []
        this.warehouseOutArr = []
        this.deliverGoodsArr = []
        this.warehouseArr = []
        this.getOrderStateNum()
        
      }else if(this.business == 'buyer'){
        // console.log('business',this.business)
        this.menu = this.buyMenu
        this.buyer()
        this.order_type = 2
        this.is_sales = 0
        this.printArr = []
        this.warehouseOutArr = []
        this.deliverGoodsArr = []
        this.warehouseArr = []
      }
      return this.$route.params.business
    }
  }, 
  watch: {
      'print_outStock': function(){
        this.editPrintValue()
      },
      'businessC': function () {
        
      },
      'staffInfo': function(){
        this.getOrderList()
        this.getOrderStateNum()
      }
      // 'order_filter':function(){
      //   sessionStorage.setItem('saveSearchValue',JSON.stringify({value:this.order_filter}))
      // }
  },
  methods: {
    settingBoxVisibleShow(){
      this.settingBoxVisible = true
    },
    editPrintValue(){
      let value = ''
      if(this.userInfo.other_setting){
        value = JSON.parse(this.userInfo.other_setting)
        value.lbl_printOutStock = this.print_outStock
        value = JSON.stringify(value)
      }else{
        value = JSON.stringify({lbl_printOutStock:this.print_outStock})
      }
      this.$post('/guigui/user/editUserOther',{data:JSON.stringify({
        uid:this.userInfo.id,
        other_setting:value
      })},res => {
        this.$get('/system/wechat_app/user_info',{
          phone:this.userInfo.phone
        },res => {
          if(res.data){
            this.$store.commit('setUserInfo',res.data)
          }
        })
      })
    },
    getAddress(){
      // this.axios.get('https://ggtools.thinkerx.com/erp/get_address',{
      //   params:{
      //     uid:this.userInfo.id,
      //     condition: 'default'
      //   }
      // }).then(res => {
      //   if(res.data.data.length){
      //     this.address = res.data.data[0]
      //   }
      // })
      this.$get("/py/erp/get_address",{
        uid:this.userInfo.id,
        condition: 'default'
      },res => {  
        if(res.data.length){
          this.address = res.data[0]
        }
      })
    },
    //打印
    yesPrint(storageInfo){
      this.printArr.push(storageInfo[0])
      console.log('打印数据',this.printArr)
    },
    showOutStockBox(orderInfo){
      this.warehouseOutArr.push(orderInfo)
      // console.log('出库数据',this.warehouseOutArr)
      this.deliverGoodsArr.push(orderInfo)
      // console.log('发货oid数据',this.deliverGoodsArr)
      this.warehouseArr.push(orderInfo)
      // console.log('入库数据',this.deliverGoodsArr)
    },
    noPrint(id){
      let printArr = this.printArr
      for(let i in printArr){
        if(printArr[i].orderId == id){
          printArr.splice(i,1)
        }
      }
      // console.log('删除后打印数据',this.printArr)

      let warehouseOutArr = this.warehouseOutArr
      for(let i in warehouseOutArr){
        if(warehouseOutArr[i].id == id){
          warehouseOutArr.splice(i,1)
        }
      }
      // console.log('删除后出库数据',this.warehouseOutArr)

      let deliverGoodsArr = this.deliverGoodsArr
      for(let i in deliverGoodsArr){
        if(deliverGoodsArr[i].id == id){
          deliverGoodsArr.splice(i,1)
        }
      }
      // console.log('删除后发货数据',this.deliverGoodsArr)

      let warehouseArr = this.warehouseArr
      for(let i in warehouseArr){
        if(warehouseArr[i].id == id){
          warehouseArr.splice(i,1)
        }
      }
      // console.log('删除后入库数据',this.warehouseArr)
    },

    restoreTmpPageInfo() {
        /* let basicInfo = {
          name: this.orderInfo.name,
          phone: this.orderInfo.phone,
          address: this.orderInfo.address,
          remark: this.orderInfo.remark

        }
        const storageInfo = [{
          // type: this.pageType,
          title: '柜柜云仓销售单',
          type: 'sale',
          list: this.orderInfo.commodity_list,
          basicInfo,
          statistics: {
            totalPrice: this.cost,//总金额
            discount_cost: this.orderInfo.discount_cost,//抵扣
            final_cost: this.orderInfo.final_cost,//折后（总计金额）
            receivedFunds: this.orderInfo.paid,//已收
            remainPrice: this.orderInfo.unpaid//尾款
          }
        }] */
      const key = `print-${new Date().getTime()}`;
      window.sessionStorage.setItem(key, JSON.stringify(this.printArr));
      return key;
    },
     openPrint() {
       if(this.printArr.length != 0){
        const key = this.restoreTmpPageInfo();
        // 勾选了打印即自动出库
        if(this.print_outStock && this.business == 'seller'){
          let tableData = []
          let formData = []
          console.log(1111)
          this.warehouseArr.forEach(item => {
            // 找出没有出库的订单tableData
            let importNedeNum = 0
            let importedNum = 0
            item.commodity_list.forEach(e => {
              importNedeNum += e.count
              importedNum += e.out_count
            })
            if(importNedeNum != importedNum && importNedeNum != 0){
              tableData.push(item)
            }
          })
          // console.log(tableData)
          let bindList = []
          tableData.forEach(item => {
            let commodity_list = item.commodity_list.filter(e => {
              if(e.id> 0 && e.count > 0){
                // 空白商品和数量为0的商品不做出库
                return e
              }
            })
            bindList[item.id] = []
            commodity_list.forEach(bindItem => {
              bindList[item.id].push({
                id:bindItem.commodity_id,
                bind_order_id:bindItem.bind_order_id,
                out_count:bindItem.count
              })
            })
            let data = handlePartOutImportStock(commodity_list,'out',this.supplierInfo,this.userInfo)
            if(data.data.length){
              data.order_id = item.id
              data.supplier_name = item.name
              data.payed_money = item.manual_flag?item.balance.paid:item.final_cost
              formData.push(data)
            }
          })
          // console.log(bindList)
          // console.log(formData)
          if(formData.length){
            formData.forEach(item => {
              this.$requests.saveBill(item).then((res) => {
                  if (res) {
                    this.getOrderList()
                    console.log('出库成功')
                  }
              })
            })
            bindList.forEach(item => {
              this.$requests.sellerBuyerBindOrderId(item).then(res =>{
                  
              })
            })
          }
          
        }
        window.open(`./printOrder.html?hash=${key}`);
       }else{
         this.$message({
           message:'请勾选订单再进行打印',
           type: 'warning',
           duration:'1000'
         })
       }
       
     /*  if(this.business == 'seller'){
        const key = this.restoreTmpPageInfo();
        window.open(`./printOrder.html?hash=${key}`);
      }else if(this.business == 'buyer'){
        this.$message({
          duration: '1000',
          message: '待开发',
        })
      } */
    },
    // 出库 start
    warehouseOutClick(){
      // 当前订单生成的出入库单的已收款金额
      // this.outStockInfo = this.orderList.filter(item => {
      //   if(item.id == id){
      //     return item
      //   }
      // })[0]
      
      // this.payed_money = this.outStockInfo.manual_flag?this.outStockInfo.balance.paid:this.outStockInfo.final_cost
      // this.payed_name = this.outStockInfo.name
      // this.order_id = id
      if(this.warehouseOutArr.length == 0){
        this.$message({
          duration: '2000',
          message: '请选择一个订单进行出库!',
        })
        return
      }
      if(this.warehouseOutArr.length > 1){
        this.$message({
          duration: '2000',
          message: '暂不支持多个订单进行出库!',
        })
        return
      }
      if(this.warehouseOutArr[0].delete_flag == 1){
         this.$message({
          message:'该商品已下架，不可出库！',
          duration:'2000'
        })
        return
      }
      let importNedeNum = 0
      let importedNum = 0
      let goodsList = this.warehouseOutArr[0].commodity_list
      goodsList.forEach(item => {
        importNedeNum += item.count
        importedNum += item.out_count
      })
      if(importNedeNum == 0){
        this.$message({
          message:'数量为0，无法出库',
          duration:'1000'
        })
        return
      }
      if(importNedeNum == importedNum){
        this.$message({
          message:'该订单已全部出库！',
          duration:'1000'
        })
        return
      }
      this.outStockBoxShow = true
    },
    hideOutStockBox(){
      this.outStockBoxShow = false
    },
    // 出库 end
    upDataOrderList(){//收款一次更新订单列表
      this.getOrderList()
    },
    deliverGoodsClick(){//发货
      if(this.deliverGoodsArr.length == 0){
        this.$message({
          duration: '2000',
          message: '请选择一个订单进行发货！',
        })
        return
      }
      if(this.warehouseOutArr.length > 1){
        this.$message({
          duration: '2000',
          message: '暂不支持多个订单进行发货！',
        })
        return
      }
      if(this.warehouseOutArr[0].status == 2 || 
        this.warehouseOutArr[0].status == 3 || 
        this.warehouseOutArr[0].status == 5){
         this.$message({
          message:'该订单已发货！',
          duration:'2000'
        })
        return
      }
      this.deliverGoodsShow = true
    },
    hideDeliverGoods(){
      this.deliverGoodsShow = false
    },
    async DeliverGoodsUpData(){//发货完更新
      // console.log('发货完更新')
      await this.getOrderStateNum()
      this.getOrderList()
    },
    warehouseClick(){//入库
      if(this.warehouseArr.length == 0){
        this.$message({
          duration: '2000',
          message: '暂不支持线上订单入库！',
        })
        return
      }
      if(this.warehouseArr.length > 1){
        this.$message({
          duration: '2000',
          message: '暂不支持多个订单进行入库!',
        })
        return
      }
      let orderInfo = this.warehouseArr[0]
      // console.log(orderInfo)
      if(orderInfo.delete_flag == 1){//商品下架
        this.$message({
          message:'该商品已下架，不可入库！',
          duration:'2000'
        })
        return
      }
      if(orderInfo.manual_flag == 0){
        this.$message({
          message:'线上订单不能入库！',
          duration:'2000'
        })
        return
      }
      let formData = handlePartOutImportStock(orderInfo.commodity_list,'import',this.supplierInfo,this.userInfo)
      formData.supplier_name = orderInfo.s_name
      formData.payed_money = orderInfo.balance.paid
      formData.order_id = orderInfo.id
      // console.log(formData)
      // return
      this.$confirm('是否确定全部入库?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          // 入库接口，绑定采购单
          this.$requests.saveBill(formData).then((res) => {
              if (res) {
                this.$message('入库成功');
                this.getOrderList()
              }
          })
          let allBindIds = []
          orderInfo.commodity_list.forEach(item => {
            let bindIds = {
                id:item.commodity_id,
                bind_order_id:orderInfo.id,
                out_count:item.count
            }
            allBindIds.push(bindIds)
          })
          this.$requests.sellerBuyerBindOrderId(allBindIds).then(res => {

          })
        }).catch(() => {
                   
        });
    },
    //手动添加订单
    addOrder() {
      this.$router.push({
        name: 'addOrderManually',
      })
    },
    // 点击显示用户设置
    showMsgSetting(){
      this.msgSettingVisible = true;
      this.$nextTick(() => {
        const editor = new E(`#bandInput`)
        editor.config.onchange = (newHtml) => {
          this.editorData = newHtml
        }
        editor.config.height = 100
        editor.config.menus = [
          'head',
          'bold',
          'fontSize',
          'fontName',
          'italic',
          'underline',
          'strikeThrough',
          'indent',
          'lineHeight',
          'foreColor',
          'list',
          'justify',
          // 'emoticon',
          'image',
          'undo',
          'redo',
        ]
        editor.create()
        editor.txt.html('<p>' + this.idCardInfo + '</p>')
        this.editor = editor
        // 第二个
        const editor1 = new E(`#remarkInput`)
        editor1.config.onchange = (newHtml) => {
          this.editorData1 = newHtml
        }
        editor1.config.height = 140
        editor1.config.menus = [
          'head',
          'bold',
          'fontSize',
          'fontName',
          'italic',
          'underline',
          'strikeThrough',
          'indent',
          'lineHeight',
          'foreColor',
          'list',
          'justify',
          // 'emoticon',
          'image',
          'undo',
          'redo',
        ]
        editor1.create()
        editor1.txt.html('<p>' + this.shipmentsInfo + '</p>')
        this.editor1 = editor1
      })
    },
    getMsgSetting(){
      // this.axios({
      //   method: 'POST',
      //   url: 'https://guicloud.thinkerx.com/api/user/getUserSetting',
      //   data: {
      //     uid: this.userInfo.id,
      //     key: 'receiv_setting'
      //   }
      // }).then( (res) => {
      //   if(res.data.status == 1){
      //     if(JSON.stringify(res.data.data).indexOf('value') < 0){
      //       // console.log(1)
      //     }else{
      //       let userset = JSON.parse(res.data.data.value)
      //       this.idCardInfo = userset[0].idcard;
      //       this.shipmentsInfo = userset[0].shipments;
      //     }
      //   }
      // })
      this.$post("/api/user/getUserSetting",{
        uid: this.userInfo.id,
        key: 'receiv_setting'
      },res => {
         if(res.status == 1){
          if(JSON.stringify(res.data).indexOf('value') < 0){
            // console.log(1)
          }else{
            let userset = JSON.parse(res.data.value)
            this.idCardInfo = userset[0].idcard;
            this.shipmentsInfo = userset[0].shipments;
          }
        }
      })
    },
    // 提交销售单格式信息配置
    msgSettingSubmit(){
      let userSetting = []
      userSetting.push(
        // {
        //   idcard: this.idCardInfo,
        //   shipments: this.shipmentsInfo
        // }
        {
          idcard: this.editorData,
          shipments: this.editorData1
        }
      )
      // console.log(userSetting)
      // this.axios({
      //   method: 'POST',
      //   url: 'https://guicloud.thinkerx.com/api/user/saveUserSetting',
      //   data: {
      //     uid: this.userInfo.id,
      //     supplier_id: this.supplier_id,
      //     key: 'receiv_setting',
      //     value: JSON.stringify(userSetting),
      //   }
      // }).then(  (res) => {
      //   this.$message({
      //     type: 'success',
      //     message: '保存成功',
      //   })
      //   this.msgSettingVisible = false;
      // })
      this.$post("/api/user/saveUserSetting",{
          uid: this.userInfo.id,
          supplier_id: this.supplier_id,
          key: 'receiv_setting',
          value: JSON.stringify(userSetting),
      },res => {
        this.$message({
          type: 'success',
          message: '保存成功',
        })
        this.getMsgSetting()
        this.msgSettingVisible = false;
      })
    },
    addPurchaseOrder(){
      this.$router.push({
        name: 'addPurchaseOrderManually',
      })
    },
    toPurchase(){
      this.$router.push({
        name: 'Shop'
      })
    },
    cancelPayment() {
      clearInterval(this.queryStatusInterval);
      this.paymentPanelShown = false;
      // 跳转到订单页
    },
    skipToOrderList() {
      clearInterval(this.queryStatusInterval);
     /*  this.$router.replace({
        name: 'QueryOrder'
      }); */
      this.paymentPanelShown = false;
      //获取订单列表
      // this.changeMenu(2)

      
      /* this.axios({
        method: 'GET',
        url: 'https://ggtools.thinkerx.com/erp/get_order_new',
        params: {
          uid: this.userInfo.id
        }
      }).then(res => {
        console.log('获取订单列表',res.data)
        this.orderList = res.data.data.order
      }) */
    },
    //买卖家订单
    seller(){//卖家
      this.business = 'seller'
      this.getOrderList()
    },
    buyer(){//买家
      this.business = 'buyer'
      this.getOrderList()
    },
    payOrder(id) {
      // console.log(id)
      const payload = {
        uid: this.userInfo.id,
        oids: [id],
        pay_way: '2',
        pay_type: 'html',
        platform: 1
      }
      this.$requests.getPaymentLink(payload).then((res) => {
        // console.log('*********',res)
         this.wechatLink = res.codeUrl;
       /*  switch('2') {
          case '2':
            this.wechatLink = res.codeUrl;
            break;
          default:
            break;
        } */
        this.paymentId = res.payment_id;
        this.paymentPanelShown = true;
        this.queryStatusInterval = setInterval(() => {
          if (this.paymentId !== '') {
            this.$requests.getOrderStatus({
              payment_id: this.paymentId
            }).then((res) => {
              switch(res.status) {
                // 未付款和未付清
                case 0: case 4: case 5:
                  break;
                case -1:
                  this.$message('支付已失效');
                  this.skipToOrderList();
                  break;
                default:
                  this.$message('支付成功');
                  this.skipToOrderList();
                  break;
              }
            })
          }
        }, 5000)
      })
    },
    confirmReceipt(oid,uid){
      // console.log('确认收货',oid,uid)
      // this.axios({
      //   method: 'POST',
      //   url: 'https://ggtools.thinkerx.com/erp/order_completed',
      //   data: {
      //     uid:uid,
      //     order_id:oid
      //   }
      // }).then(res => {
      //   // console.log('确认收货',res.data)
      //   if(res.data.status == 1){
      //     this.$message('收货成功')
      //   }
      // })
      this.$post("/py/erp/order_completed",{
        uid:uid,
        order_id:oid
      },res => {
        if(res.status == 1){
          this.$message('收货成功')
        }
      })
      this.changeMenu(5)
      
    },
    confirmShipment(oid,sid){
      //  console.log('确认发货',oid,sid)
      //   this.axios({
      //   method: 'POST',
      //   url:'https://ggtools.thinkerx.com/erp/order_wait_reward',
      //   data:{
      //       supplier_id:sid,
      //       order_id:oid
      //   }
      // }).then(res => {
      //   // console.log('确认发货',res.data)
      //   if(res.data.status == 1){
      //     this.$message('发货成功')
      //   }
      // })
      this.$post("/py/erp/order_wait_reward",{
        supplier_id:sid,
        order_id:oid
      },res => {
         if(res.status == 1){
          this.$message('发货成功')
        }
      })
      this.changeMenu(2)
      
    },
   /*  confirmCollection(data){
       this.axios({
        method: 'POST',
        url: 'https://ggtools.thinkerx.com/erp/add_manual_payment',
        data: data
      }).then(res => {
        console.log('确认添加收款',res.data)
      })
    }, */

    dev(now){
      // console.log(now)
      
       this.$message({
          duration: 1000,
          message: '待开发'
        });
      return

      this.now = now
      this.getOrderList()
    },
    search() {
      this.getOrderList()
    },
    orderItemSearch(key){//点击客户搜索
      this.order_filter = key
      this.getOrderList()
    },
    clearKeyword() {
      this.order_filter = ''
      this.buyerOrderFilter = ''
      this.getOrderList()
    },
    async modifyOrderState(id){
      console.log(555)
      // console.log('传过来的',id)
      // this.changeMenu(id)
      // this.status_mark = id
      await this.getOrderStateNum()
      this.getOrderList()

    },
    changeMenu(id) {
      // return;
      // console.log('ididdididi',id)
      this.target = id;
      // console.log('target',this.target)

      
      // if(id == 1){//全部订单
      //   if(this.business == 'seller'){
      //     this.sellerStatus = []
      //   }else if(this.business == 'buyer'){
      //     this.status = []
      //   }
      //   this.getOrderList()
      // }else if(id == 2){//待收款0
      //   if(this.business == 'seller'){
      //     this.sellerStatus = [0]
      //   }else if(this.business == 'buyer'){
      //     this.status = [0]
      //   }
      //   this.getOrderList()
      // }else if(id == 3){//已收款（只有手动添加的订单）
      //   if(this.business == 'seller'){
      //     this.sellerStatus = [1,2,3,4]
      //   }else if(this.business == 'buyer'){
      //     this.status = [1]
      //   }
      //   this.getOrderList()
      // }else if(id == 4){//待发货
      //   if(this.business == 'seller'){
      //     this.sellerStatus = [1]
      //   }else if(this.business == 'buyer'){
      //     this.status = [2]
      //   }
      //   this.getOrderList()
      // }else if(id == 5){//已完成
      //   if(this.business == 'seller'){
      //     this.sellerStatus = [3]
      //   }else if(this.business == 'buyer'){
      //     this.status = [3]
      //   }
      //   this.getOrderList()
      // }



    //文件夹式订单分类
      if(this.business == 'seller'){
        switch(id) {
          case -1:
            this.businessPage = 1
            this.status_mark = ''
            this.getOrderList()
            this.getOrderStateNum()
            break;
          case 0:
            if(this.business == 'seller'){
              this.businessPage = 1
              this.status_mark = 0
              this.getOrderList()
              this.getOrderStateNum()
            }
            break;
          case 1:
            this.businessPage = 1
            this.status_mark = 1
            this.getOrderList()
            this.getOrderStateNum()
            break;
          case 2:
            this.businessPage = 1
            this.status_mark = 2
            this.getOrderList()
            this.getOrderStateNum()
            break;
          case 3:
            this.businessPage = 1
            this.status_mark = 3
            this.getOrderList()
            this.getOrderStateNum()
          break;
          case 4:
            this.businessPage = 1
            this.status_mark = 4
            this.getOrderList()
            this.getOrderStateNum()
          break;
          case 5:
            this.businessPage = 1
            this.status_mark = 5
            this.getOrderList()
            this.getOrderStateNum()
          break;
          case 6:
            this.businessPage = 1
            this.status_mark = 6
            this.getOrderList()
            this.getOrderStateNum()
          break;
          case 7:
            this.businessPage = 1
            this.status_mark = 7
            this.getOrderList()
            this.getOrderStateNum()
          break;
          case 8:
            this.businessPage = 1
            this.status_mark = 8
            this.getOrderList()
            this.getOrderStateNum()
          break;
          case 9:
            this.businessPage = 1
            this.status_mark = 9
            this.getOrderList()
            this.getOrderStateNum()
          break;
          case 10:
            this.businessPage = 1
            this.status_mark = 10
            this.getOrderList()
            this.getOrderStateNum()
          break;
          // default:
            
          // break;
        }
        console.log(this.status_mark)
      }else if(this.business == 'buyer'){
        if(id == 1){//全部订单
          this.status = []
          this.getOrderList()
        }else if(id == 2){//待收款0
          this.status = [0]
          this.getOrderList()
        }else if(id == 3){//已收款（只有手动添加的订单）
          this.status = [1]
          this.getOrderList()
        }else if(id == 4){//待发货
          this.status = [2]
          this.getOrderList()
        }else if(id == 5){//已完成
          this.status = [3]
          this.getOrderList()
        }
      }

    },
    checkLogistic() {
      // console.log('查看物流');
      this.$message('接口开发中');
    },
    deleteOrder(id) {
      // console.log('删除订单',id);
      let deleteId = []
      deleteId.push(id)
      // this.$message('接口开发中');
      this.$confirm('此操作将永久删除该订单, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.$post("/py/erp/delete_order_new",{
            uid: this.userInfo.id,
            supplier_id: this.supplier_id,
            oids: deleteId,
            role: this.business
          },res => {
            if(res.status == 1){
                this.$message({
                  type: 'success',
                  message: '删除成功!'
                });
                this.getOrderStateNum()
                this.getOrderList()
              }
          })
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          });          
        });
      
    },
    payment(id){
      // console.log('立即支付订单',id)
      this.payId = id
      let list = this.orderList
      for(let i in list){
        if(list[i].id == id){
          this.totalAmount = list[i].totalAmount
        }
      }
      //微信支付接口（获取二维码url）

      this.$message('待开发');
      // this.paymentMaskIsShow = true
    },
    hideMask(event){
      let event1 = event.currentTarget;
      let event2 = event.target
      if(event1 == event2){
        this.paymentMaskIsShow = false
      }
    },
    noPay(){
      this.paymentMaskIsShow = false
    },
    ggPayment(){
      this.$message('待开发');
      this.paymentMaskIsShow = false
    },
    getOrderList(){
      if(this.business == 'seller'){
        this.printArr = []
        this.warehouseOutArr = []
        this.deliverGoodsArr = []
        this.warehouseArr = []
        this.orderList = []
        
        // console.log('供应商id',this.supplierInfo.id)
        let page = this.businessPage
        if(this.supplierInfo){
          console.log(this.status_mark)
            let payload = {
              supplier_id: this.supplierInfo.id,
              status: this.sellerStatus,
              order_filter: this.order_filter,
              status_mark: this.status_mark,
              page: page
            }
            if(this.staffInfo){
              payload.staff_id = this.staffInfo.id
            }
            this.$post("/py/erp/supplier_get_order",payload,res => {
              console.log('供应商销售订单列表',res.data)
              this.orderList = res.data.order
              let total = res.data.order_total
              this.businessTotalPage = Math.ceil(parseInt(total)/12)
              if(this.businessTotalPage == 0){
                this.businessTotalPage = 1
              }
              for(let i in this.orderList){//是否下架
               this.orderList[i].delete_flag = 0 //没下架
                for(let j in this.orderList[i].commodity_list){
                    if(this.orderList[i].commodity_list[j].delete_flag == 1 && this.orderList[i].commodity_list[j].id != 0){
                      this.orderList[i].delete_flag = 1 //下架
                    }
                  
                }
              }
              for(let i in this.orderList){//是否手输入商品
                this.orderList[i].warehouseOut = 1//不是手输入 可出库
                for(let j in this.orderList[i].commodity_list){
                  if(this.orderList[i].commodity_list[j].id == 0){
                    this.orderList[i].warehouseOut = 0//是手数入 不可出库
                  }
                }
              }
            })
        }else{
          let payload = {
            uid: this.userInfo.id,
            status: this.sellerStatus,
            order_filter: this.order_filter,
            status_mark: this.status_mark,
            page:page
          }
          if(this.staffInfo){
            payload.staff_id = this.staffInfo.id
          }
          this.$post("/py/erp/guigui_user_get_order",payload,res => {
            this.orderList = res.data.order
              let total = res.data.order_total
              this.businessTotalPage = Math.ceil(parseInt(total)/12)
              if(this.businessTotalPage == 0){
                this.businessTotalPage = 1
              }
              // for(let i in this.orderList){
              //   for(let j in this.moneyList){
              //     if(this.orderList[i].id == this.moneyList[j].order_id){
              //       // console.log('进来了',this.orderList[i].id,this.moneyList[j].order_id)
              //       this.orderList[i].balance = this.moneyList[j]
              //     }
              //   }
              // }
              for(let i in this.orderList){
                for(let j in this.orderList[i].commodity_list){
                  if(this.orderList[i].commodity_list[j].delete_flag == 1){
                    this.orderList[i].delete_flag = 1
                  }
                }
              }
          })
        }
      }else if(this.business == 'buyer'){
        this.printArr = []
        this.warehouseOutArr = []
        this.deliverGoodsArr = []
        this.warehouseArr = []
        this.orderList = []
        let page = this.userPage
        let payload = {
          uid: this.userInfo.id,
          status: this.status,
          order_filter: this.buyerOrderFilter,
          // status_mark: this.status_mark,
          page: page
        }
        if(this.staffInfo){
          payload.staff_id = this.staffInfo.id
        }
        this.$post("/py/erp/get_order_new",payload,res => {
          this.orderList = res.data.order
          let total = res.data.order_total
          this.userTotalPage = Math.ceil(parseInt(total)/12)
          if(this.userTotalPage == 0){
            this.userTotalPage = 1
          }
          // for(let i in this.orderList){
          //   for(let j in this.moneyList){
          //     if(this.orderList[i].id == this.moneyList[j].order_id){
          //       this.orderList[i].balance = this.moneyList[j]
          //     }
          //   }
          // }
          // console.log('采购订单添加尾款',this.orderList)
           console.log('采购订单列表修改',res.data)
          for(let i in this.orderList){
            for(let j in this.orderList[i].commodity_list){
              if(this.orderList[i].commodity_list[j].delete_flag == 1){
                this.orderList[i].delete_flag = 1
              }
            }
          }
        })
      }
      
    },
    getOrderStateNum(){//获取不同订单分类下的总数量
      let payload = {
        uid: this.userInfo.id,
        supplier_id: this.supplier_id,
        is_sales: this.is_sales
      }
      if(this.staffInfo){
        payload.staff_id = this.staffInfo.id
      }
      this.$get("/py/erp/get_cloud_order_status_num",payload,res => {
        // console.log('数量',res)
        let list = res.data
        if(this.business == 'seller'){
          for(let i in list){
            for(let j in this.sellMenu){
              if(list[i].id == this.sellMenu[j].id){
                // console.log('进来了')
                this.sellMenu[j].num = list[i].num
              }
            }
          }
        }else if(this.business == 'buyer'){
          for(let i in list){
            for(let j in this.buyMenu){
              if(list[i].id == this.buyMenu[j].id){
                this.buyMenu[j].num = list[i].num
              }
            }
          }
        }
        
      })
    },
    //采购分页
    previousPage(){
      this.orderList = []
      let page = --this.userPage
      this.getOrderList()
      /* this.axios({
        method: 'GET',
        url: 'https://ggtools.thinkerx.com/erp/get_order_new',
        params: {
          uid: this.userInfo.id,
          status: this.status,
          page: --this.userPage
        }
      }).then(res => {
          this.orderList = res.data.data.order
      }) */
    },
    nextPage(){
      this.orderList = []
      let page = ++this.userPage
      this.getOrderList()
      /* this.axios({
        method: 'GET',
        url: 'https://ggtools.thinkerx.com/erp/get_order_new',
        params: {
          uid: this.userInfo.id,
          status: this.status,
          page: ++this.userPage
        }
      }).then(res => {
          this.orderList = res.data.data.order
      }) */
        
    },
    //销售分页
    businessPreviousPage(){
      this.orderList = []
      // console.log('供应商id',this.supplierInfo.id)
      let page = --this.businessPage
      this.getOrderList()
       /*  this.axios({
          method: 'POST',
          url: 'https://ggtools.thinkerx.com/erp/supplier_get_order',
          data: {
            supplier_id: this.supplierInfo.id,
            status: this.sellerStatus,
            page: --this.businessPage
          }
        }).then(res =>  {
          this.orderList = res.data.data.order
        }) */
    },
    businessNextPage(){
      console.log('当前页',this.businessPage)
      this.orderList = []
      // console.log('供应商id',this.supplierInfo.id)
      let page = ++this.businessPage
      /* this.getOrderList()
        this.axios({
          method: 'POST',
          url: 'https://ggtools.thinkerx.com/erp/supplier_get_order',
          data: {
            supplier_id: this.supplierInfo.id,
            status: this.sellerStatus,
            page: ++this.businessPage
          }
        }).then(res =>  {
          this.orderList = res.data.data.order
        }) */
        
    },
   getMoney(){//获取尾款 已收款(修改)
        this.$post("/py/erp/get_order_manual_price",{
          uid: this.userInfo.id,
          supplier_id: this.supplier_id,
          order_type: this.order_type
        },res => {
          // console.log('尾款',res)
          this.moneyList = res.data.order_list
        })
    },
    getSupplierList(){
      this.$requests.getSupplierList(this.userInfo.id,{}).then(res => {
        // console.log(res)
        this.forwardSupplierList = res
      })
    },
  },
  async mounted(){
    if(this.userInfo.other_setting){
        let other_set = JSON.parse(this.userInfo.other_setting)
        if(other_set.lbl_printOutStock){
          this.print_outStock = true
        }else{
          this.print_outStock = false
        }
      }else{
        this.print_outStock = false
      }
    // this.$post('/guigui/user/editUserOther',{data:JSON.stringify({
    //   uid:28608,
    //   logo_url:'http://eggrj.oss-cn-hangzhou.aliyuncs.com/cloudPictures/11_25/mWXNiitr5H.JPG'
    // })},res => {

    // })
    
    // console.log(this.$store.state.identityMode,this.$store.getters.staffInfo)
    // console.log('11111',this.$route.params.business)
    // this.business = this.$route.params.business
    // console.log('获取供应商信息 ',this.supplierInfo)
    // console.log('登录信息',this.userInfo)
    /* this.business = this.$route.params.business */
   /*  if(!this.supplierInfo && this.business == 'seller'){
      // this.$message('你还不是供应商！') 
      // this.business = 'buyer'
    }else{
      this.getOrderList()
    } */
    this.getAddress()
    // this.getMoney()
    this.getOrderStateNum()
    if(this.business == 'seller'){
      this.getMsgSetting()
    }else{
      await this.getSupplierList()
    }
    if(sessionStorage.saveSearchValue){
      this.order_filter = JSON.parse(sessionStorage.saveSearchValue).value
      this.getOrderList()
    }else{
      this.getOrderList()
    }
    
    
  }
}
</script>

<style lang="less" scoped>
@mainMarginTop: 28px;
@menuMarginBottom: 28px;
@header: 60px;
@footer: 60px;
.wrapper {
  width: 100%;
  height: calc(100vh - @footer - @header - @mainMarginTop);
  background-color:#eeeeee;
  .payment_mask_box{
    position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    z-index: 1;
    background-color: rgba(77, 77, 77, 0.6);
    .payment_box{
      width: 300px;
      height: 360px;
      border-radius: 10px;
      background-color: rgba(247, 248, 250, 1);
      margin: 0 auto;
      position: relative;
      top: 50%;
      transform: translateY(-50%);
      .back_img_box{
       /*  border: 1px solid red; */
        text-align: right;
        padding: 20px 20px 3px;
        .backImg{
          cursor: pointer;
        }
      }
      .order_title{
        font-size: 14px;
        color: rgba(51, 51, 51, 1);
        font-weight: bold;
      }
      .QRcode_box{
        width: 120px;
        height: 120px;
        margin: 16px auto 20px;
        img{
          width: 100%;
          height: 100%;
        }
      }
      .payPrice{
        font-size: 20px;
        color: rgba(81, 71, 231, 1);
        margin-bottom: 20px;
      }
      .tips{
        font-size: 14px;
        color: rgba(94, 94, 94, 1);
      }
      .other_payments_box{
       /*  border: 1px solid red; */
        display: flex;
        justify-content: space-between;
        padding: 0 20px;
        height: 40px;
        line-height: 40px;
        margin-top: 10px;
        .el-button{
          padding: 5px;
        }
      }
    }
  }
  .nowBox{
        width: 1440px;
        padding: 0 5px;
        margin: 20px auto;
        display: flex;
        -webkit-box-align: center;
        -ms-flex-align: center;
        align-items: center;
      /* div{
        margin-right:40px;
        font-size: 18px;
        cursor: pointer;
        color:#6c6c6c;
      } */
      .business_box{
        width: 260px;
        display: flex;
        justify-content: space-around;
        span{
          display: inline-block;
          font-size: 18px;
          cursor: pointer;
          color:#6c6c6c;
          height: 50px;
          line-height: 50px;
          color: rgba(153, 153, 153, 1);
        }
        .active {
          color: rgba(51, 51, 51, 1);
          font-weight: bold;
        }
    }
  }
    
  .main {
    margin: auto;
    // margin-top: 28px;
    padding-bottom: 10px;
    height: 100%;
    display: flex;
    justify-content: center;
    .sideNav {
      height: 100%;
      width: 240px;
      background-color: white;
      border-radius: 10px;
      margin-right: 30px;
      .orderstate{
        line-height: 3em;
        font-size: 18px;
        color: rgba(51, 51, 51, 1);
        text-align: center;
        cursor: pointer;
        >span:nth-child(2){
          margin-left: 5px;
        }
      }
      .active {
        color: rgba(81, 71, 231, 1);
      }
      .order_category_box{
        // border-bottom: 1px solid rgba(235, 235, 235, 1);
        display: flex;
        justify-content: space-around;
        span{
          display: inline-block;
          font-size: 15px;
          height: 50px;
          line-height: 50px;
          color: rgba(153, 153, 153, 1);
        }
      }
    }
    .content {
        height: 100%;
        display: flex;
        flex-direction: column;
        .header {
          flex-shrink: 0;
          display: flex;
          justify-content: space-between;
          align-items: center;
          margin-bottom: 18px;
          // border: 1px solid red;
          .header_left{
            display: flex;
            align-items: center;
            .filter-sale-order{
              margin-left: 20px;
            }
            .addOrderIconBtn{
              // border: 1px solid red;
              background-color: #6376F7;
              border-radius: 4px;
              padding: 5px 5px;
              height:30px;
              color:#ffffff;
              cursor: pointer;
              font-size: 16px;
              display: flex;
              align-items:center;
              line-height: 30px;
              // margin-left: 20px;
              i{
                  font-size: 25px;
                  margin-right:5px;
              }
              img{
                width: 25px;
                height: 25px;
              }
              span{
                margin-left: 4px;
                font-size: 18px;
                color: rgba(255, 255, 255, 1);
              }
            }
            .addGoodsIconBtn{
              border-radius: 4px;
              // padding: 5px 10px;
              font-size: 16px;
              margin-left: 36px;
              height:30px;
              cursor: pointer;
              font-size: 16px;
              display: flex;
              align-items:center;
              line-height: 30px;
              // margin-left: 20px;
              i{
                  font-size: 25px;
                  margin-right:5px;
              }
            }
            .operBtn{
              cursor: pointer;
              margin-left: 41px;
              span{
                color: rgba(51, 51, 51, 1);
                font-size: 18px;
              }
              i{
                font-size: 25px;
              }
              img{
                width: 25px;
                height: 25px;
                position: relative;
                top: -1px;
              }
            }
          }
          .header_right{
            display: flex;
            align-items: center;
            .toggle-show-sale{
              margin-right: 10px;
            }
            .orderMsgSetting{
              margin-right: 28px;
              color: rgba(99, 118, 247, 1);
              font-size: 16px;
              cursor: pointer;
            }
            .el-dialog{
              .remark_box{
                margin-bottom: 20px;
              }
              .el-col.el-col-8{
                text-align: right;
              }
              .remark_msg{
                display: inline-block;
                margin-top: 10px;
              }
              .remark_input{
                width: 300px;
                height: 90px;
                resize: none;
              }
              button{
                width: 100px;
                height: 30px;
                line-height: 30px;
                border: none;
                background: linear-gradient(131deg, #87B3FF 0%, #6376F7 100%);
                border-radius: 14px;
                color: #fff;
                &:hover{
                  background: #6376F7;
                }
              }
              button:first-child{
                margin-right: 20px;
              }
              .msgSet_box{
                text-align: right;
                width: 93%;
                >button{
                  cursor: pointer;
                  outline: none;
                }
              }
              .remark_area{
                font-weight: bold;
              }
            }
            .timeSelector {
              margin-right: 16px;
              width: 120px;
              .el-select {
                /deep/ input {
                  font-size: 16px;
                  line-height: 30px;
                  height: 30px;
                }
                /deep/ .el-input__icon {
                  line-height: 30px;
                }
              }
              
            }
            .keywordSearching {
              height: 30px;
              width: 270px;
              border-radius: 15px;
              border: 1px solid #D9D9D9;
              // border: 1px solid #6376F7;
              // box-shadow: 0 0 6px rgba(247, 106, 0, 0.5);
              display: flex;
              justify-content: space-between;
              overflow: hidden;
              background-color: white;
              padding: 0 10px;
              input{
                outline: none;
              }
              img{
                margin-right: 8px;
              }
              // input[type=text]:focus{ border: 1px solid #AFECAB; }
              .buttons {
                display: flex;
                align-items: center;
                img {
                  cursor: pointer;
                }
                
              }

              input::placeholder {
                color: rgba(184, 184, 184, 1);
                font-size: 15px;
              }
              input {
                font-size: 15px;
                border:none;
                flex: 1;
                // margin-right: 15px;
              }
            }
          }
        }
        .sales-order-table{
          width: 1510px;
          margin: 0 auto;
        }
        .orderList {
          flex: 1;
          height: 762px;
          overflow-y: auto;
          width: 1130px;
          .orderItemWrapper{
            position: relative;
            .mask{
              position: absolute;
              bottom: 0;
              left: 0;
              z-index: 1;
              width: 100%;
              height: 100%;
              background-color: rgba(51, 51, 51, 0.4);
              border-radius: 10px;
              div{
                color: #ffffff;
                position: relative;
                top: 50%;
                transform: translateY(-50%);
                font-size: 20px;
                
              }
            }
          }
          .orderItemWrapper:not(:last-child) {
            margin-bottom: 12px;
          }
          
        }
    }
  }
  
  .order_paging_box{
    // border: 1px solid red;
    width: 1440px;
    margin: 0 auto;
    text-align: right;
    padding: 0 17px;
  }
  .outMask{
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 2;
    background-color: rgba(51, 51, 51, 0.5);
  }
  
}
.w-e-text ul li {
  list-style: square !important;
}
.w-e-text ol li {
  list-style: decimal !important;
}



</style>